import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PopBrand } from './PopCulture';

export default function LoadingScreen() {
  const { t } = useTranslation();
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsStuck(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  return <div className="qpug-loading-screen">
    <section className="qpug-loading-card" aria-label={t('pop.loadingLabel')}>
      <div className="qpug-loading-emblem"><h1 aria-label="Question pour un Geek"><PopBrand /></h1></div>
      <div className="qpug-loading-beat" aria-hidden="true"><i /><i /><i /></div>
      <p className="qpug-loading-status" role="status">{t('common.loading')}</p>
      <p className="qpug-loading-hint">{t('pop.loadingHint')}</p>
      <div className="qpug-loading-track" aria-hidden="true"><span /></div>
      {isStuck && <div className="qpug-loading-recovery">
        <p role="status">{t('pop.loadingSlow')}</p>
        <button type="button" className="qpug-button qpug-outline" onClick={() => window.location.reload()}>{t('pop.loadingReload')}</button>
      </div>}
    </section>
  </div>;
}
